import { ROUTES } from "@routing/routes";
import { NotFoundContent } from "@/Features/Shared/ErrorPages/NotFoundContent";

export const AdminNotFoundPage = () => {
    return (
        <NotFoundContent
            primaryTo={ROUTES.ADMIN_DASHBOARD}
            primaryLabel="Go to dashboard"
        />
    );
};
